import { createContext, useContext, useMemo, useCallback, useState } from 'react';
import PropTypes from 'prop-types';

const FlowContext = createContext(null);

export function FlowProvider({ children }) {
  const [flowMethods, setFlowMethods] = useState({
    saveFlow: null
  });

  // Use useCallback to maintain reference stability
  const registerMethod = useCallback((methodName, method) => {
    setFlowMethods((prev) => {
      // Only update if the method reference has changed
      if (prev[methodName] === method) {
        return prev;
      }
      return {
        ...prev,
        [methodName]: method
      };
    });
  }, []);

  // Use useMemo to maintain object reference
  const value = useMemo(
    () => ({
      ...flowMethods,
      registerMethod
    }),
    [flowMethods, registerMethod]
  );

  return <FlowContext.Provider value={value}>{children}</FlowContext.Provider>;
}

FlowProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export const useFlow = () => {
  const context = useContext(FlowContext);
  if (!context) {
    throw new Error('useFlow must be used within a FlowProvider');
  }
  return context;
};
